
/* Studio Mottos frame preview v1.12.0.
   Display only: never writes forms, SKUs, prices or cart data. */
(function(global){
  'use strict';

  const normalize=v=>String(v??'').toLowerCase().replace(/[×✕]/g,'x').replace(/[″“”"']/g,'').replace(/\s+/g,'').trim();
  const match=(values,value)=>values.some(v=>normalize(v)===normalize(value));

  function sizeFor(profile,label){
    const raw=String(label??'');
    const printumoA4=/^\s*\(\s*A4\s*\)\s*21(?:\.0+)?\s*[x×✕]\s*29\.7(?:0+)?\s*cm\s*$/i.test(raw);

    if(printumoA4){
      const base=(profile.sizes||[]).find(row=>
        [row.label,...(row.aliases||[])].some(value=>
          /^8x11(?:in|inch|inches)?$/.test(normalize(value)) ||
          /^a4$/.test(normalize(value)) ||
          /^21x29\.7cm$/.test(normalize(value))
        )
      );

      if(base){
        return {
          ...base,
          cm:[21,29.7],
          matCm:base.matCm?[...base.matCm]:null
        };
      }

      return {
        label:'A4',
        cm:[21,29.7],
        matCm:[12.7,17.78],
        faceCm:Number(profile.faceCm??1.5)
      };
    }

    const metric=raw.match(/^\s*([\d.]+)\s*[x×✕]\s*([\d.]+)\s*cm\s*\//i);
    const iso=raw.match(/\(\s*(A[0-5])\s*\)\s*$/i);
    const candidates=[raw];

    if(metric)candidates.push(metric[1]+' x '+metric[2]+' cm');
    if(iso)candidates.push(iso[1]);

    for(const candidate of candidates){
      const n=normalize(candidate);
      for(const row of profile.sizes||[]){
        if(match([row.label,...(row.aliases||[])],candidate)){
          return {
            ...row,
            cm:[...row.cm],
            matCm:row.matCm?[...row.matCm]:null
          };
        }

        const wanted=n.match(/^([\d.]+)x([\d.]+)(cm)?$/);
        const original=normalize(row.label).match(/^([\d.]+)x([\d.]+)(cm)?$/);

        if(wanted&&original&&wanted[1]===original[2]&&wanted[2]===original[1]&&wanted[3]===original[3]){
          return {
            ...row,
            cm:[row.cm[1],row.cm[0]],
            matCm:row.matCm?[row.matCm[1],row.matCm[0]]:null
          };
        }

        if(metric&&candidate!==raw&&candidate!==iso?.[1]&&wanted?.[3]==='cm'){
          const w=Number(wanted[1]),h=Number(wanted[2]);
          if(w===row.cm[0]&&h===row.cm[1]){
            return {
              ...row,
              cm:[...row.cm],
              matCm:row.matCm?[...row.matCm]:null
            };
          }
          if(w===row.cm[1]&&h===row.cm[0]){
            return {
              ...row,
              cm:[row.cm[1],row.cm[0]],
              matCm:row.matCm?[row.matCm[1],row.matCm[0]]:null
            };
          }
        }
      }
    }

    // Older Printumo catalogs use nominal inch labels for metric products.
    // Resolve these only after explicit profile rows, so custom dimensions win.
    const isPrintumo=!/artelo/i.test(String(profile.name||''))&&(
      /printumo|artist/i.test(String(profile.name||''))||
      Object.keys(profile.frames||{}).some(frame=>normalize(frame)==='oaknature')
    );
    if(isPrintumo){
      const nominal=normalize(raw).match(/^(11x15|15x11|15x19|19x15|19x27|27x19|27x39|39x27)(?:in|inch|inches)?$/);
      const legacy={
        '11x15':{cm:[30,40],matCm:[21,29.7],faceCm:1.5},
        '15x19':{cm:[40,50],matCm:[30,40],faceCm:1.5},
        '19x27':{cm:[50,70],matCm:[40,50],faceCm:1.5},
        '27x39':{cm:[70,100],matCm:[50,70],faceCm:2}
      };
      if(nominal){
        const parts=nominal[1].split('x').map(Number);
        const landscape=parts[0]>parts[1];
        const key=[...parts].sort((a,b)=>a-b).join('x');
        const fallback=legacy[key];
        const configured=(profile.sizes||[]).find(row=>
          row.cm?.[0]===fallback.cm[0]&&row.cm?.[1]===fallback.cm[1]
        );
        const base=configured||{label:raw,...fallback};
        return {
          ...base,
          cm:landscape?[...base.cm].reverse():[...base.cm],
          matCm:base.matCm?(landscape?[...base.matCm].reverse():[...base.matCm]):null
        };
      }
    }

    if(candidates.some(candidate=>/^8x11(?:in|inch|inches)?$/.test(normalize(candidate)))){
      return {
        label:'8 × 11″',
        cm:[20.32,27.94],
        matCm:[12.7,17.78],
        faceCm:1.5
      };
    }

    throw Error('No dimensions configured for size: '+label);
  }

  function geometry(profile,variant,optionNames){
    if(!variant?.id)throw Error('No valid selected variant');

    const value=name=>{
      const i=optionNames.findIndex(n=>normalize(n)===normalize(name));
      if(i<0)throw Error('Missing product option: '+name);
      return variant.options?.[i]??variant['option'+(i+1)];
    };

    const sizeLabel=value(profile.sizeOption);
    const frameLabel=value(profile.frameOption);
    const matLabel=profile.matOption?value(profile.matOption):null;
    const row=sizeFor(profile,variant.__collectionSize||profile.previewSize||sizeLabel);
    const unframed=match(profile.unframed||[],frameLabel);
    const frameEntry=Object.entries(profile.frames||{}).find(([name])=>normalize(name)===normalize(frameLabel));

    if(!unframed&&!frameEntry)throw Error('Unknown frame option: '+frameLabel);

    let mat=false;
    if(matLabel!==null){
      if(match(profile.matValues||[],matLabel))mat=true;
      else if(!match(profile.noMat||[],matLabel))throw Error('Unknown mat option: '+matLabel);
    }

    if(mat&&(!row.matCm||profile.matAvailable===false))throw Error('No mat dimensions for this selection');
    if(mat&&unframed&&profile.matWithoutFrame!=='printed-border')throw Error('Unframed mat behavior is not configured');

    const [w,h]=row.cm;
    const face=unframed?0:Number(row.faceCm??profile.faceCm);
    const [aw,ah]=mat?row.matCm:[w,h];

    if(![w,h,aw,ah].every(v=>Number.isFinite(v)&&v>0)||!Number.isFinite(face)||face<0||aw>w||ah>h){
      throw Error('Invalid frame or mat dimensions');
    }

    return {
      w,h,aw,ah,face,
      outerW:w+2*face,
      outerH:h+2*face,
      mat,unframed,
      texture:frameEntry?.[1],
      sizeLabel,frameLabel,matLabel,collectionSize:variant.__collectionSize
    };
  }

  function cropRect(iw,ih,w,h,fit='cover',fx=.5,fy=.5){
    if(fit==='contain'){
      const s=Math.min(w/iw,h/ih);
      return {
        sx:0,sy:0,sw:iw,sh:ih,
        dx:(w-iw*s)/2,
        dy:(h-ih*s)/2,
        dw:iw*s,dh:ih*s
      };
    }

    const s=Math.max(w/iw,h/ih),sw=w/s,sh=h/s;
    return {
      sx:(iw-sw)*Math.max(0,Math.min(1,fx)),
      sy:(ih-sh)*Math.max(0,Math.min(1,fy)),
      sw,sh,dx:0,dy:0,dw:w,dh:h
    };
  }

  function matOpening(g){
    if(!g.mat)return '';
    const inches=v=>Number((v/2.54).toFixed(2)).toString();
    return 'Mat opening: '+inches(g.aw)+' × '+inches(g.ah)+' in';
  }

  function previewCaption(g,profile){
    const names={
      natural:'Natural Oak Frame',
      dark:'Walnut Oak Frame',
      black:'Black Oak Frame',
      white:'White Oak Frame'
    };
    const frame=g.unframed?'Unframed Print':(profile.frameDisplayNames?.[g.texture]||names[g.texture]||g.frameLabel);
    const mat=g.mat?(profile.matDisplayName||'White Mat'):'No Mat';
    return g.sizeLabel+' · '+frame+' - '+mat+(g.mat?'\n'+matOpening(g):'');
  }

  function previewLayout(g,profile,resolution){
    const row=sizeFor(profile,g.collectionSize||profile.previewSize||g.sizeLabel);
    const face=/artelo/i.test(String(profile.name||''))?
      Number(g.unframed?profile.faceCm??row.faceCm:g.face):
      Number(row.faceCm??profile.faceCm);

    if(!Number.isFinite(face)||face<0)throw Error('Invalid reserved frame dimensions');

    const scale=Math.min(
      resolution*.80/(g.w+2*face),
      resolution*.80/(g.h+2*face)
    );
    const W=g.outerW*scale,H=g.outerH*scale,F=g.face*scale;
    return {
      scale,W,H,F,
      x:(resolution-W)/2,
      y:(resolution-H)/2
    };
  }

  function artworkGeometry(profile,variant,options,iw,ih){
    const state=geometry(profile,variant,options);
    // Use the same source ratio before and after the artwork decodes.
    if(/artelo/i.test(String(profile.name||''))&&iw>0&&ih>0){
      const originalMin=Math.min(state.w,state.h);
      const area=state.w*state.h;
      const ratio=iw/ih;
      state.w=Math.sqrt(area*ratio);
      state.h=Math.sqrt(area/ratio);
      state.face=state.unframed?0:state.face*Math.min(state.w,state.h)/originalMin;
      state.aw=state.w;
      state.ah=state.h;
      state.outerW=state.w+2*state.face;
      state.outerH=state.h+2*state.face;
    }
    return state;
  }

  const api={
    normalize,sizeFor,geometry,artworkGeometry,cropRect,
    matOpening,previewLayout,previewCaption
  };

  if(typeof module!=='undefined'&&module.exports){
    module.exports=api;
    return;
  }

  global.SMFramePreviewMath=api;
  if(customElements.get('sm-frame-preview'))return;

  const cache=new Map();
  let renderBuffer;

  function loadProfile(url){
    if(!cache.has(url)){
      cache.set(url,fetch(url).then(r=>{
        if(!r.ok)throw Error('Frame profile could not be loaded');
        return r.json();
      }).catch(e=>{
        cache.delete(url);
        throw e;
      }));
    }
    return cache.get(url);
  }

  function ready(img){
    return new Promise((resolve,reject)=>{
      if(img.complete){
        img.naturalWidth?resolve(img):reject(Error('Preview image unavailable'));
        return;
      }
      img.addEventListener('load',()=>resolve(img),{once:true});
      img.addEventListener('error',()=>reject(Error('Preview image unavailable')),{once:true});
    });
  }

  class FramePreview extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();
      this.version=(this.version||0)+1;
      this.state=null;
      this.renderedFrame=null;
      this.boot().catch(e=>this.fail(e));
    }

    disconnectedCallback(){
      this.abort.abort();
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.version++;
    }

    async boot(){
      const parse=s=>JSON.parse(this.querySelector(s).textContent);
      this.variant=parse('[data-preview-variant]');
      this.options=parse('[data-preview-options]');
      this.variants=parse('[data-preview-variants]');
      this.profile=parse('[data-preview-profile]')||await loadProfile(this.dataset.profileUrl);

      if(typeof this.profile==='string')this.profile=JSON.parse(this.profile);
      if(!this.isConnected)return;

      this.art=this.querySelector('[data-preview-artwork]');
      this.canvas=this.querySelector('[data-preview-canvas]');
      this.caption=this.querySelector('[data-preview-caption]');
      this.textures=Object.fromEntries(
        [...this.querySelectorAll('[data-preview-texture]')].map(i=>[i.dataset.previewTexture,i])
      );

      const signal=this.abort.signal;

      if(this.hasAttribute('data-cart-preview')){
        this.resize=new ResizeObserver(()=>{
          if(this.state)this.draw(this.canvas,this.state);
        });
        this.resize.observe(this);
        await this.update();
        return;
      }

      if(this.hasAttribute('data-collection-card')){
        this.collectionVariants=new Map();
        this.resize=new ResizeObserver(()=>{
          if(this.state&&this.collectionVisible!==false&&this.clientWidth>0&&this.lastDrawWidth!==this.clientWidth){
            this.draw(this.canvas,this.state);
          }
        });
        this.resize.observe(this);
        this.canvas.addEventListener('contextrestored',()=>{
          this.restoreCollectionFrame(this.dataset.requestedFrame||'natural',true);
        },{signal});
        if(global.IntersectionObserver){
          this.collectionVisible=false;
          this.visibility=new IntersectionObserver(entries=>{
            for(const entry of entries){
              this.collectionVisible=entry.isIntersecting;
              if(entry.isIntersecting)this.restoreCollectionFrame(
                this.dataset.requestedFrame||document.documentElement.dataset.smCollectionFrame||'natural'
              );
            }
          },{rootMargin:'200px'});
          this.visibility.observe(this);
        }else{
          this.collectionVisible=true;
          this.setCollectionFrame(document.documentElement.dataset.smCollectionFrame||'natural');
        }
        return;
      }

      const form=document.getElementById(this.dataset.form);
      if(!form)throw Error('Product form not found');

      form.addEventListener('variant:change',e=>this.syncVariant(e.detail.variant),{signal});

      const section=this.closest('.shopify-section')||
        this.closest('product-rerender')||
        this.closest('product-gallery').parentElement;

      document.addEventListener('sm:variant-change',e=>{
        if(section.contains(e.target)||e.detail?.formId===this.dataset.form){
          this.syncVariant(e.detail?.variant);
        }
      },{signal});

      const actualId=form.querySelector('[name="id"]')?.value;
      const current=this.variants.find(v=>String(v.id)===String(actualId));
      if(current)this.variant=current;

      this.resize=new ResizeObserver(()=>{
        if(this.state)this.draw(this.canvas,this.state);
      });
      this.resize.observe(this);

      await this.update();
      this.warmTextures();
    }

    restoreCollectionFrame(color,force=false){
      this.dataset.requestedFrame=color;
      if(this.collectionVisible===false||this.clientWidth===0)return;
      if(this.state&&this.renderedFrame===color&&this.dataset.ready==='true'){
        // Repaint once on an actual cache/context restoration. Merely entering
        // the viewport again should not clear and redraw an intact canvas.
        if(force||this.lastDrawWidth!==this.clientWidth||this.canvas.hidden){
          this.draw(this.canvas,this.state);
        }
        this.canvas.hidden=false;
      }else{
        this.setCollectionFrame(color);
      }
    }

    setCollectionFrame(color){
      if(!this.hasAttribute('data-collection-card')||!this.profile)return;
      this.dataset.requestedFrame=color;
      if(this.collectionVisible===false)return;
      if(this.renderedFrame===color&&this.state&&this.dataset.ready==='true'&&
         this.dataset.selectedFrame===color)return;
      const cached=this.collectionVariants?.get(color);
      if(cached){
        this.variant=cached;
        this.dataset.selectedFrame=color;
        return this.update();
      }
      const normalizeValue=v=>normalize(v);
      const index=name=>(this.options||[]).findIndex(n=>normalizeValue(n)===normalizeValue(name));
      const sizeIndex=index(this.profile.sizeOption),frameIndex=index(this.profile.frameOption);
      const matIndex=this.profile.matOption?index(this.profile.matOption):-1;
      if(sizeIndex<0||frameIndex<0)return;
      const variants=this.variants||[];
      const sizes=[...new Set(variants.map(v=>v.options?.[sizeIndex]).filter(Boolean))];
      const rank=size=>{const n=normalizeValue(size);if(/18x24/.test(n))return 0;if(/19x27|50x70cm/.test(n))return 1;return 2;};
      const area=size=>{try{const r=sizeFor(this.profile,size);return r.cm[0]*r.cm[1];}catch(e){return 0;}};
      sizes.sort((a,b)=>rank(a)-rank(b)||area(b)-area(a));
      const desired={natural:['natural','nature','oak nature'],dark:['walnut','dark oak','oak dark'],black:['black'],white:['white'],none:['no frame','poster only','unframed']}[color]||[];
      const matches=v=>desired.some(x=>normalizeValue(v).includes(normalizeValue(x)));
      const availableFrames=color==='none'?(this.profile.unframed||[]):Object.keys(this.profile.frames||{});
      const frame=availableFrames.find(matches);
      if(!frame){this.fail(Error('Frame not configured: '+color));return;}
      const noMat=(this.profile.noMat||[])[0];
      let picked=null;
      for(const size of sizes){
        const candidates=variants.filter(v=>normalizeValue(v.options?.[sizeIndex])===normalizeValue(size));
        const real=candidates.find(v=>normalizeValue(v.options?.[frameIndex])===normalizeValue(frame)&&(matIndex<0||(this.profile.noMat||[]).some(x=>normalizeValue(x)===normalizeValue(v.options?.[matIndex]))));
        if(real){picked=real;break;}
        if(candidates.length){
          // Collection previews are display-only: synthesize a valid display
          // combination when the catalog lacks this exact frame/mat variant.
          picked={...candidates[0],options:[...candidates[0].options]};
          picked.options[frameIndex]=frame;
          if(matIndex>=0&&noMat)picked.options[matIndex]=noMat;
          break;
        }
      }
      if(!picked){this.fail(Error('No suitable collection preview size'));return;}
      picked={...picked,__collectionSize:picked.options[sizeIndex]};
      this.collectionVariants?.set(color,picked);
      this.variant=picked;
      this.dataset.selectedFrame=color;
      return this.update();
    }

    warmTextures(){
      const connection=navigator.connection;
      if(this.hasAttribute('data-cart-preview')||
         connection?.saveData||
         /^(slow-)?2g$/.test(connection?.effectiveType||''))return;

      const queue=Object.values(this.textures).filter(img=>!img.getAttribute('src'));

      const next=()=>{
        if(!this.isConnected||!queue.length||document.visibilityState==='hidden')return;
        const img=queue.shift();
        img.fetchPriority='low';
        if(!img.getAttribute('src'))img.src=img.dataset.src;
        ready(img).catch(()=>{}).finally(()=>{
          if(queue.length)schedule();
        });
      };

      const schedule=()=>{
        if(global.requestIdleCallback){
          global.requestIdleCallback(next,{timeout:3000});
        }else{
          global.setTimeout(next,300);
        }
      };
      schedule();
    }

    getZoomData(){
      if(!this.state||this.dataset.ready!=='true')return null;
      const canvas=document.createElement('canvas');
      this.draw(canvas,this.state,1600);
      const src=canvas.toDataURL('image/png');
      return {
        thumbnailElement:this.canvas,
        src,msrc:src,
        width:1600,height:1600,
        alt:this.canvas.getAttribute('aria-label')||this.art.alt,
        thumbCropped:false
      };
    }

    syncVariant(variant){
      if(!variant)return Promise.resolve();
      if(this.dataset.ready==='true'&&String(this.variant?.id)===String(variant.id)){
        return Promise.resolve();
      }

      this.variant=variant;
      return this.update().then(()=>{
        const carousel=this.closest('product-gallery')?.carousel;
        const cell=this.closest('.product-gallery__media');
        if(carousel?.isScrollable&&this.dataset.ready==='true'){
          requestAnimationFrame(()=>{
            if(this.isConnected){
              carousel.select(carousel.cells.indexOf(cell),{instant:true});
            }
          });
        }
      });
    }

    async update(){
      const token=++this.version;

      try{
        let state=artworkGeometry(this.profile,this.variant,this.options,
          this.art.naturalWidth||Number(this.art.getAttribute('width')),
          this.art.naturalHeight||Number(this.art.getAttribute('height')));
        if(this.dataset.ready!=='true'&&state.unframed&&!state.mat){
          const layout=previewLayout(state,this.profile,100);
          Object.assign(this.art.style,{
            position:'absolute',left:layout.x+'%',top:layout.y+'%',
            width:layout.W+'%',height:layout.H+'%',padding:'0',
            objectFit:/artelo/i.test(String(this.profile.name||''))||this.dataset.fit==='contain'?'contain':'cover',
            objectPosition:Number(this.dataset.focusX)+'% '+Number(this.dataset.focusY)+'%',
            boxShadow:'0 2px 6px rgba(40,35,28,.10)'
          });
          this.dataset.placeholderReady='true';
          this.art.hidden=false;
        }
        await ready(this.art);
        state=artworkGeometry(this.profile,this.variant,this.options,
          this.art.naturalWidth,this.art.naturalHeight);


        if(!state.unframed){
          const texture=this.textures[state.texture];
          if(texture){
            if(!texture.getAttribute('src') && texture.dataset.src)texture.src=texture.dataset.src;
            // All cards use the product's photographic texture, never a
            // temporary CSS-colored frame that changes appearance after load.
            await ready(texture);
          }else throw Error('Frame texture unavailable');
        }

        if(token!==this.version||!this.isConnected)return;

        this.state=state;
        this.draw(this.canvas,state);
        this.art.hidden=true;
        this.canvas.hidden=false;
        this.dataset.ready='true';
        if(this.hasAttribute('data-collection-card'))this.renderedFrame=this.dataset.selectedFrame;
        this.querySelector('[data-preview-error]').hidden=true;
        this.querySelector('[data-preview-loading]').hidden=true;

        this.caption.textContent=previewCaption(state,this.profile);
        this.caption.hidden=true;
        this.canvas.setAttribute('aria-label',this.caption.textContent);

      }catch(e){
        if(token===this.version)this.fail(e);
      }
    }

    fail(error){
      if(!this.isConnected)return;

      if(this.hasAttribute('data-cart-preview')){
        this.dataset.ready='false';
        this.state=null;
        this.hidden=true;
        return;
      }

      this.dataset.ready='false';
      this.dataset.placeholderReady='true';
      this.art?.removeAttribute('style');
      this.state=null;
      this.querySelector('[data-preview-loading]').hidden=true;
      this.querySelector('[data-preview-artwork]').hidden=false;
      this.querySelector('[data-preview-canvas]').hidden=true;
      this.querySelector('[data-preview-caption]').hidden=true;

      const msg=this.querySelector('[data-preview-error]');
      msg.textContent=this.hasAttribute('data-editor')?
        error.message:
        'Frame preview unavailable for this selection.';
      msg.hidden=false;

      console.warn('[SM frame preview]',error.message);
    }

    drawPhotographicFrame(c,g,{x,y,W,H,F}){
      const surface=this.textures[g.texture];
      const iw=surface.naturalWidth,ih=surface.naturalHeight;
      const coordinates=this.profile.frontPhoto?.[g.texture]||
        this.profile.frontPhoto||{};
      const bounds=coordinates.bounds||[.196875,.125,.803125,.875];
      const face=(coordinates.faceWidth||.0265625)*iw;
      const [l,t,r,b]=[
        bounds[0]*iw,bounds[1]*ih,
        bounds[2]*iw,bounds[3]*ih
      ];

      if(![l,t,r,b,face].every(Number.isFinite)||
         face<=0||r<=l+2*face||b<=t+2*face){
        throw Error('Invalid frame front-photo coordinates');
      }

      const sw=r-l,sh=b-t,pad=0;
      const sourceCorner=face+pad;
      const targetCorner=F*(1+pad/face);

      // Keep resampling inside the wooden face: the adjacent photo opening
      // is white and can otherwise bleed into the inner edge of the frame.
      const innerTrim=Math.min(1,face*.08);
      const outerTrim=Math.min(1,face*.08);
      const sx=[l+outerTrim,l+sourceCorner,r-sourceCorner+innerTrim];
      const sy=[t+outerTrim,t+sourceCorner,b-sourceCorner+innerTrim];
      const widths=[sourceCorner-innerTrim-outerTrim,sw-2*sourceCorner,sourceCorner-innerTrim-outerTrim];
      const heights=[sourceCorner-innerTrim-outerTrim,sh-2*sourceCorner,sourceCorner-innerTrim-outerTrim];

      const dx=[x,x+targetCorner,x+W-targetCorner];
      const dy=[y,y+targetCorner,y+H-targetCorner];
      const dw=[targetCorner,W-2*targetCorner,targetCorner];
      const dh=[targetCorner,H-2*targetCorner,targetCorner];

      for(let row=0;row<3;row++){
        for(let col=0;col<3;col++){
          if(row===1&&col===1)continue;

          const extraX=col<2?.5:0;
          const extraY=row<2?.5:0;

          c.drawImage(
            surface,
            sx[col],sy[row],
            widths[col]*(1+extraX/dw[col]),
            heights[row]*(1+extraY/dh[row]),
            dx[col],dy[row],
            dw[col]+extraX,dh[row]+extraY
          );
        }
      }
    }

    draw(canvas,g,fixed){
      // Paint all layers offscreen, then replace the visible bitmap in one
      // operation. Resizing/clearing the visible canvas between layers caused
      // flashes during restoration and repeated observer callbacks.
      renderBuffer=renderBuffer||document.createElement('canvas');
      this.paint(renderBuffer,g,fixed);
      if(canvas.width!==renderBuffer.width)canvas.width=renderBuffer.width;
      if(canvas.height!==renderBuffer.height)canvas.height=renderBuffer.height;
      const context=canvas.getContext('2d');
      context.save();
      context.globalCompositeOperation='copy';
      context.drawImage(renderBuffer,0,0);
      context.restore();
      if(canvas===this.canvas)this.lastDrawWidth=this.clientWidth;
    }

    paint(canvas,g,fixed){
      const resolution=fixed||
        (this.hasAttribute('data-cart-preview')?360:0)||
        (this.hasAttribute('data-collection-card')?
          Math.min(1000,Math.max(320,Math.round(this.clientWidth*Math.min(devicePixelRatio||1,1.5)))):0)||
        Math.min(1600,Math.max(600,
          Math.round(this.clientWidth*Math.min(devicePixelRatio||1,2))
        ));

      if(canvas===this.canvas)this.lastDrawWidth=this.clientWidth;
      canvas.width=resolution;
      canvas.height=resolution;

      const c=canvas.getContext('2d');
      const {scale,W,H,F,x,y}=previewLayout(g,this.profile,resolution);

      c.fillStyle='#f8f7f5';
      c.fillRect(0,0,resolution,resolution);

      if(!g.unframed||g.mat){
        c.save();
        c.shadowColor=g.unframed?'rgba(40,35,28,.10)':'rgba(0,0,0,.16)';
        c.shadowBlur=resolution*(g.unframed ? .010 : .016);
        c.shadowOffsetY=resolution*(g.unframed ? .004 : .009);
        // Match the shadow caster to the frame so fractional outer pixels
        // cannot expose a white backing halo after mobile downsampling.
        c.fillStyle=g.unframed?'#fff':
          ({natural:'#cfb98e',dark:'#72513b',black:'#252525',white:'#ecebe7'}[g.texture]||'#b7a58a');
        c.fillRect(x,y,W,H);
        c.restore();
      }

      c.fillStyle=g.mat?
        (this.profile.matColor||'#fafaf9'):
        '#faf9f6';

      if(!g.unframed||g.mat)c.fillRect(x+F,y+F,g.w*scale,g.h*scale);

      if(g.mat&&g.unframed){
        c.strokeStyle='rgba(70,65,55,.14)';
        c.lineWidth=resolution/600;
        c.strokeRect(x,y,W,H);
      }

      const ax=x+F+(g.w-g.aw)*scale/2;
      const ay=y+F+(g.h-g.ah)*scale/2;
      const aw=g.aw*scale;
      const ah=g.ah*scale;

      // Artelo uses contain; other profiles keep their existing fit setting.
      const fit=/artelo/i.test(String(this.profile.name||''))?
        'contain':
        (this.dataset.fit==='contain'?'contain':'cover');

      const rect=cropRect(
        this.art.naturalWidth,
        this.art.naturalHeight,
        aw,ah,fit,
        Number(this.dataset.focusX)/100,
        Number(this.dataset.focusY)/100
      );

      // A subpixel overlap beneath the frame prevents the pale backing
      // showing through where fractional canvas coordinates meet.
      const bleed=F&&!g.mat?.75:0;
      c.save();
      if(g.unframed&&!g.mat){
        // Cast the shadow from the artwork itself, not a white rectangle
        // underneath it whose antialiased edges can show as a pale border.
        c.shadowColor='rgba(40,35,28,.10)';
        c.shadowBlur=resolution*.010;
        c.shadowOffsetY=resolution*.004;
      }
      c.drawImage(
        this.art,
        rect.sx,rect.sy,rect.sw,rect.sh,
        ax+rect.dx-bleed,ay+rect.dy-bleed,
        rect.dw+2*bleed,rect.dh+2*bleed
      );
      c.restore();

      if(g.mat){
        const bevelCm=Number(this.profile.matBevelCm??.18);
        const matMargin=Math.min(
          (g.w-g.aw)*scale/2,
          (g.h-g.ah)*scale/2
        );

        const B=Math.min(
          Math.max(resolution*.002,
            scale*(Number.isFinite(bevelCm)&&bevelCm>=0?bevelCm:.18)
          ),
          matMargin*.35
        );

        const strip=(points,x1,y1,x2,y2,start,end)=>{
          c.save();
          c.beginPath();
          points.forEach(([px,py],i)=>
            i?c.lineTo(px,py):c.moveTo(px,py)
          );
          c.closePath();
          const gradient=c.createLinearGradient(x1,y1,x2,y2);
          gradient.addColorStop(0,start);
          gradient.addColorStop(1,end);
          c.fillStyle=gradient;
          c.fill();
          c.restore();
        };

        if(B>0){
          strip(
            [[ax-B,ay-B],[ax+aw+B,ay-B],[ax+aw,ay],[ax,ay]],
            ax,ay-B,ax,ay,'#e8e8e5','#d5d5d1'
          );
          strip(
            [[ax-B,ay-B],[ax,ay],[ax,ay+ah],[ax-B,ay+ah+B]],
            ax-B,ay,ax,ay,'#ecece9','#dadad6'
          );
          strip(
            [[ax+aw,ay],[ax+aw+B,ay-B],[ax+aw+B,ay+ah+B],[ax+aw,ay+ah]],
            ax+aw,ay,ax+aw+B,ay,'#ffffff','#f6f6f3'
          );
          strip(
            [[ax,ay+ah],[ax+aw,ay+ah],[ax+aw+B,ay+ah+B],[ax-B,ay+ah+B]],
            ax,ay+ah,ax,ay+ah+B,'#ffffff','#f6f6f3'
          );
        }
      }

      if(F){
        this.drawPhotographicFrame(c,g,{x,y,W,H,F});

        const px=x+F,py=y+F;
        const pw=W-2*F,ph=H-2*F;
        const depth=Math.max(1.2,Math.min(F*.38,resolution*.008));

        const shade=(x1,y1,x2,y2,bounds,opacity)=>{
          const gradient=c.createLinearGradient(x1,y1,x2,y2);
          gradient.addColorStop(0,'rgba(0,0,0,'+opacity+')');
          gradient.addColorStop(1,'rgba(0,0,0,0)');
          c.fillStyle=gradient;
          c.fillRect(...bounds);
        };

        shade(px,py,px,py+depth,[px,py,pw,depth],.24);
        shade(px,py,px+depth,py,[px,py,depth,ph],.19);
        shade(px+pw,py,px+pw-depth,py,[px+pw-depth,py,depth,ph],.07);
        shade(px,py+ph,px,py+ph-depth,[px,py+ph-depth,pw,depth],.09);
      }
    }
  }

  customElements.define('sm-frame-preview',FramePreview);

})(typeof window==='undefined'?globalThis:window);
